import React from "react";
import Loading from "../../shared/components/misc/Loading";
import numeral from 'numeral';
import { round } from 'lodash'

export default function OutstandingBalance({
  creditLimit,
  loading,
}) {
  if (loading) return <Loading/>;

  const {
    amount_balance_outstanding,
    overdue_count
  } = creditLimit;

  if (amount_balance_outstanding <= 0.0) { return null }

  function hasOverdue() {
    return overdue_count > 0;
  }

  function amountBalanceOutstanding() {
    const rounded = round(amount_balance_outstanding, 2)
    const split = numeral(rounded).format('0,0.00').split('.')
    return {
      raw: rounded,
      whole_number: split[0],
      decimal: split[1]
    }
  }

  function amountBalanceOutstandingWholeNumber() {
    const whole_number = amountBalanceOutstanding().whole_number
    return whole_number || "0"
  }

  function amountBalanceOutstandingDecimal() {
    const decimal = amountBalanceOutstanding().decimal
    return decimal || "00"
  }


  return (
    <section className="cardSection _textAlign_center">
      <h2 className="subhead -darkBlue"> You owe a total of </h2>

      <div className="_displayFlex _justifyContent-center _alignItems-flex-start _marginBottom--xxxsmall">
        <div className="_displayFlex _justifyContent-center _alignItems-flex-start">
          <span className="-primary _marginTop--xxsmall _marginRight--xxxsmall">₱</span>
          <h1 className="ultra -primary _marginBottom-none" data-testid="balance-outstanding-whole-number">
            { amountBalanceOutstandingWholeNumber() }
          </h1>
          <span className="-primary _marginBottom--xxxsmall _alignSelf-center emphasize"  data-testid="balance-outstanding-decimal">
            { `.${amountBalanceOutstandingDecimal()}` }
          </span>
          { hasOverdue() &&
            <h1 className="ultra -primary _marginBottom-none _marginLeft--xxxsmall" data-testid="overdue-asterisk">
              *
            </h1>
          }
        </div>

      </div>

      { hasOverdue() &&
        <p className="byline --small" data-testid="overdue-note">
          *This amount does not include additional fees on your overdue payments yet.
        </p>
      }
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/features/home/components/OutstandingBalance.js